import { createAxiosInstance } from '@speechki-frontend/shared/axios';

const PAGE_SIZE = 50;
const URL = process.env.VUE_APP_CRM_API_URL;
const axios = createAxiosInstance(URL);

export const fetchUsersSchema = () => axios.get('/api/v1/users/users/schema/');

export const fetchUsers = async (params = {}) => {
    const url = '/api/v1/users/users/';
    const { results } = await axios.get(url, {
        params: {
            page_size: PAGE_SIZE,
            ...params,
        },
    });
    return results;
};

export const fetchCustomersMembers = async (params = {}) => {
    const url = '/api/v1/customers/customers_members/';
    const { results } = await axios.get(url, {
        params: {
            page_size: PAGE_SIZE,
            ...params,
        },
    });
    return results;
};

export const fetchCustomersEmployees = async (params = {}) => {
    const url = '/api/v1/customers/employees/';
    const { results } = await axios.get(url, {
        params: {
            page_size: PAGE_SIZE,
            ...params,
        },
    });
    return results;
};

export const fetchUser = (id) => axios.get(`/api/v1/users/users/${id}/`);
